import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300 ease-in-out",
          "focus:outline-none focus:ring-1 focus:scale-[1.02] focus:-translate-y-0.5",
          "dark:focus:ring-orange-500/30 dark:focus:border-orange-500 dark:focus:shadow-[0_0_15px_rgba(249,115,22,0.15)]",
          "focus:ring-teal-500/30 focus:border-teal-500 focus:shadow-[0_0_15px_rgba(20,184,166,0.15)]",
          "hover:border-primary/50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
